import request from '@/utils/request'

const basePath = '/api/question_bank'


/**
 * 获取题库列表
 * @returns {*}
 */
export function getQuestionBankList(params) {
    return request({
        url: `${basePath}`,
        method: 'GET',
        params: params
    })
}

/**
 * 创建题目
 * @param data
 * @returns {*}
 */
export function createQuestion(data) {
    return request({
        url: `${basePath}/${data.questionBankId}/question`,
        method: 'POST',
        data: data
    })
}

/**
 * 确认试卷
 * @param paperIds
 * @returns {*}
 */
export function certaintyPaper(paperIds) {
    return request({
        url: `${basePath}/test_paper/exam/certainty`,
        method: 'POST',
        data: {
            paper_ids: paperIds.join(',')
        }
    })
}
